// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"c6c11ba9","240":"08bee2a0","394":"c3e1e1b5","442":"c6c11ba9","851":"9346a13a","946":"fe49f7d6","959":"ca8b0094"}[chunkId] + ".chunk.css";
};